var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleStyling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,6,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,6,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,6,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,6,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,6,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,6,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,6,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,6,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,6,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,6,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,6,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,6,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,6,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,6,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,14,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,14,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,14,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,14,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,14,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,14,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,14,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,14,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,14,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,22,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,22,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,22,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,22,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,22,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,22,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,22,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,22,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,22,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,22,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,22,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,22,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,30,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,30,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,30,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,30,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,30,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,30,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,30,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,30,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,30,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,30,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,38,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,38,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,38,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,38,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,38,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,38,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,38,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,38,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,38,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,38,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,38,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,46,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,46,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,46,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,46,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,46,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,46,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,46,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,46,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,46,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,46,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,46,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,54,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,54,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,54,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,54,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,54,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,54,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,54,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,54,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,54,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,54,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,54,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,62,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,62,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,62,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,62,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,62,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,62,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,62,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,62,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,62,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,62,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,62,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,62,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,62,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,62,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,70,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,70,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,70,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,70,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,70,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,70,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,70,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,70,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,70,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,70,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,70,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,70,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,70,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,70,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,70,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,70,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,70,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,70,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,70,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,70,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,70,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,70,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,70,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,70,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,70,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,78,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,78,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,78,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,78,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,78,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,78,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,78,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,78,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,78,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,78,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,78,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,78,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,78,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,78,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,78,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,78,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,78,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,78,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,78,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,78,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,78,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,86,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,86,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,86,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,86,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,86,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,86,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,86,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,86,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,86,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,86,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,86,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,86,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,86,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,86,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,86,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,86,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,86,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,86,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,94,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,94,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,94,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,94,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,94,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,94,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,94,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,94,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,94,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,94,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,94,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,94,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,94,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,94,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,94,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,102,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,102,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,102,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,102,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,102,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,102,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,102,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,102,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,102,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,102,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,102,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,102,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,102,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,102,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,102,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,102,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,102,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,110,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,110,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,110,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,110,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,110,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,110,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,110,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,110,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,110,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,110,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,110,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,110,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,110,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,110,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,110,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,110,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,118,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,118,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,118,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,118,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,118,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,118,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,118,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,118,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,118,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,118,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,118,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,118,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,118,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,118,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,118,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,118,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,126,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,126,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,126,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,126,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,126,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,126,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,126,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,126,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,126,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,126,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,126,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,126,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,126,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,126,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,126,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,126,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,126,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,134,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,134,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,134,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,134,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,134,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,134,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,134,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,134,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,134,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,134,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,134,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,134,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,134,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,134,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,134,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,134,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,134,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,134,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,134,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,134,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,134,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,142,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,142,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,142,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,142,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,142,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,142,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,142,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,142,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,142,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,142,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,142,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,142,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,142,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,142,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,142,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,142,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,142,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,142,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,142,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,142,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,150,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,150,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,150,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,150,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,150,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,150,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,150,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,150,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,150,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,150,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,150,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,150,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,150,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,150,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,150,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,158,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,158,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,158,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,158,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,158,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,158,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,158,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,158,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,158,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,158,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,158,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,158,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,158,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,158,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,158,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,158,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,158,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,158,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,166,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,166,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,166,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,166,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,166,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,166,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,166,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,166,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,166,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,166,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,166,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,166,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,166,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,166,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,166,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,166,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,166,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,166,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,166,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,166,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,174,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,174,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,174,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,174,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,174,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,174,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,174,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,174,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,174,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,174,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,174,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,174,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,174,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,174,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,174,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,174,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,174,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,182,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,182,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,182,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,182,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,182,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,182,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,182,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,182,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,182,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,182,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,182,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,182,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,182,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,182,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,182,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,182,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,182,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,182,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,182,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,182,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,182,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,182,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,182,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,190,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,190,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 26,
    width: 8,
    height: 8,
    transform: "rotate(0,190,30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,190,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,190,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,190,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,190,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,190,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,190,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,190,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,190,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,190,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,190,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,190,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,190,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,190,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,190,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,190,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,190,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,190,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,198,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,198,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,198,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,198,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,198,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,198,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,198,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,198,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,198,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,198,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,198,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,198,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,198,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,198,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,198,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,198,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,198,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,198,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 34,
    width: 8,
    height: 8,
    transform: "rotate(0,206,38)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,206,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,206,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,206,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,206,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,206,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,206,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,206,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,206,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,206,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,206,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,214,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,214,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,214,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,214,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,214,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,214,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,214,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,214,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,214,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,214,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,214,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,214,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,214,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,214,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,214,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,222,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(0,222,22)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 42,
    width: 8,
    height: 8,
    transform: "rotate(0,222,46)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,222,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,222,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,222,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,222,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,222,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,222,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,222,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,222,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,222,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,222,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,222,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,222,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,222,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,222,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,222,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,222,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,222,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,222,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 2,
    width: 8,
    height: 8,
    transform: "rotate(0,230,6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 10,
    width: 8,
    height: 8,
    transform: "rotate(0,230,14)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 50,
    width: 8,
    height: 8,
    transform: "rotate(0,230,54)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 58,
    width: 8,
    height: 8,
    transform: "rotate(0,230,62)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,230,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,230,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,230,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,230,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,230,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,230,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,230,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,230,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,230,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,230,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,230,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,230,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,230,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,230,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,230,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,230,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,230,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,230,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,238,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,238,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,238,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,238,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,238,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,238,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,238,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,238,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,238,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,238,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,238,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,238,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,238,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,238,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,238,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,238,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,238,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,246,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,246,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,246,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,246,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,246,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,246,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,246,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 218,
    width: 8,
    height: 8,
    transform: "rotate(0,246,222)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,246,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,246,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,246,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,246,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,246,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,254,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,254,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,254,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,254,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,254,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,254,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,254,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,254,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,254,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,254,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,254,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,254,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,254,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,254,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,262,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,262,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,262,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,262,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,262,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,262,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,262,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,262,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,262,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,262,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,262,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,262,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,262,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,262,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,262,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,262,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,262,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,270,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,270,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,270,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,270,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,270,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,270,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,270,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,270,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 210,
    width: 8,
    height: 8,
    transform: "rotate(0,270,214)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,270,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,270,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,270,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 274,
    width: 8,
    height: 8,
    transform: "rotate(0,270,278)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,270,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,278,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,278,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,278,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,278,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,278,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,278,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,278,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,278,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,278,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,278,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,278,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,278,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,278,294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 66,
    width: 8,
    height: 8,
    transform: "rotate(0,286,70)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 74,
    width: 8,
    height: 8,
    transform: "rotate(0,286,78)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 82,
    width: 8,
    height: 8,
    transform: "rotate(0,286,86)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,286,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,286,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 114,
    width: 8,
    height: 8,
    transform: "rotate(0,286,118)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 122,
    width: 8,
    height: 8,
    transform: "rotate(0,286,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 138,
    width: 8,
    height: 8,
    transform: "rotate(0,286,142)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 154,
    width: 8,
    height: 8,
    transform: "rotate(0,286,158)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,286,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,286,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 178,
    width: 8,
    height: 8,
    transform: "rotate(0,286,182)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 194,
    width: 8,
    height: 8,
    transform: "rotate(0,286,198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,286,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,286,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,286,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,286,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 258,
    width: 8,
    height: 8,
    transform: "rotate(0,286,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,286,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 90,
    width: 8,
    height: 8,
    transform: "rotate(0,294,94)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 98,
    width: 8,
    height: 8,
    transform: "rotate(0,294,102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 106,
    width: 8,
    height: 8,
    transform: "rotate(0,294,110)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 130,
    width: 8,
    height: 8,
    transform: "rotate(0,294,134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 146,
    width: 8,
    height: 8,
    transform: "rotate(0,294,150)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 162,
    width: 8,
    height: 8,
    transform: "rotate(0,294,166)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 170,
    width: 8,
    height: 8,
    transform: "rotate(0,294,174)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 186,
    width: 8,
    height: 8,
    transform: "rotate(0,294,190)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 202,
    width: 8,
    height: 8,
    transform: "rotate(0,294,206)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 226,
    width: 8,
    height: 8,
    transform: "rotate(0,294,230)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 234,
    width: 8,
    height: 8,
    transform: "rotate(0,294,238)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 242,
    width: 8,
    height: 8,
    transform: "rotate(0,294,246)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 250,
    width: 8,
    height: 8,
    transform: "rotate(0,294,254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 266,
    width: 8,
    height: 8,
    transform: "rotate(0,294,270)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 282,
    width: 8,
    height: 8,
    transform: "rotate(0,294,286)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 290,
    width: 8,
    height: 8,
    transform: "rotate(0,294,294)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2,2l0,28c0,15.6,12.4,28,28,28h28V30c0-15.6-12.4-28-28-28H2z M50,50H30c-11.2,0-20-8.8-20-20v0c0-11.2,8.8-20,20-20h0c11.2,0,20,8.8,20,20V50z",
    transform: "rotate(0,30,30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,42H30C23.2,42,18,36.8,18,30v0c0-6.8,5.2-12,12-12h0c6.8,0,12,5.2,12,12V42z",
    transform: "rotate(0,30,30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M242,2l0,28c0,15.6,12.4,28,28,28h28V30c0-15.6-12.4-28-28-28H242z M290,50H270c-11.2,0-20-8.8-20-20v0c0-11.2,8.8-20,20-20h0c11.2,0,20,8.8,20,20V50z",
    transform: "rotate(90,270,30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282,42H270C263.2,42,258,36.8,258,30v0c0-6.8,5.2-12,12-12h0c6.8,0,12,5.2,12,12V42z",
    transform: "rotate(90,270,30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2,242l0,28c0,15.6,12.4,28,28,28h28V270c0-15.6-12.4-28-28-28H2z M50,290H30c-11.2,0-20-8.8-20-20v0c0-11.2,8.8-20,20-20h0c11.2,0,20,8.8,20,20V290z",
    transform: "rotate(-90,30,270)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,282H30C23.2,282,18,276.8,18,270v0c0-6.8,5.2-12,12-12h0c6.8,0,12,5.2,12,12V282z",
    transform: "rotate(-90,30,270)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#00aaff00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    height: 296,
    width: 296,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#00aaff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    height: 56,
    width: 56,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    height: 24,
    width: 24,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 2,
    height: 56,
    width: 56,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 18,
    height: 24,
    width: 24,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 242,
    height: 56,
    width: 56,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 258,
    height: 24,
    width: 24,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,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",
    x: 108,
    y: 108,
    width: "84px",
    height: "84px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleStyling);
export default __webpack_public_path__ + "static/media/simple_styling.da42cce31028a14ddf060d402391c048.svg";
export { ForwardRef as ReactComponent };